import AppRouter from './navigation/app-router';

export function AppRoot() {
  return <AppRouter />;
}

export default AppRoot;
